"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScorecardSelect = ScorecardSelect;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _classes = require("../../common/classes");
var _discreteRating = require("../../common/discreteRating");
var _hooks = require("../../common/hooks");
var _Icon = require("../icon/Icon");
var _iconNames = require("../icon/iconNames");
var _excluded = ["className", "defaultValue", "disabled", "fill", "onChange"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ScorecardSelect(_ref) {
  var className = _ref.className,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? false : _ref$fill,
    onChange = _ref.onChange,
    divProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedValue = _React$useState2[0],
    setSelectedValue = _React$useState2[1];
  var isMount = (0, _hooks.useIsMount)();
  function handleRatingClick(newSelectedValue) {
    if (disabled) return;
    setSelectedValue(newSelectedValue === selectedValue ? undefined : newSelectedValue);
  }
  React.useEffect(function () {
    if (onChange && !isMount && !disabled) onChange(selectedValue);
  }, [selectedValue]);
  var classArray = [_classes.Classes.SCORECARD_SELECT, _defineProperty({}, _classes.Classes.INTERACTIVE, !disabled), _defineProperty({}, _classes.Classes.DISABLED, disabled), className];
  var activeRating = selectedValue || undefined;
  if (activeRating) {
    classArray.push(_classes.Classes.discreteRatingClass(activeRating));
  }
  var classes = (0, _classnames.default)(classArray);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, divProps), Object.values(_discreteRating.DiscreteRating).map(function (rating) {
    var isActive = rating === selectedValue;
    return /*#__PURE__*/React.createElement(ScorecardIcon, {
      key: rating,
      activeRating: activeRating,
      handleRatingClick: handleRatingClick,
      isActive: isActive,
      rating: rating,
      fill: fill
    });
  }));
}
function ScorecardIcon(_ref4) {
  var activeRating = _ref4.activeRating,
    handleRatingClick = _ref4.handleRatingClick,
    isActive = _ref4.isActive,
    rating = _ref4.rating,
    fill = _ref4.fill;
  var iconMap = {
    1: _iconNames.IconNames16.FACE_ANGUISH,
    2: _iconNames.IconNames16.FACE_FROWN,
    3: _iconNames.IconNames16.FACE_NEUTRAL,
    4: _iconNames.IconNames16.FACE_SMILE,
    5: _iconNames.IconNames16.FACE_GRIN
  };
  var content = activeRating && isActive ? /*#__PURE__*/React.createElement(_Icon.Icon16, {
    icon: iconMap[activeRating]
  }) : /*#__PURE__*/React.createElement("span", null, rating);
  var handleClick = function handleClick() {
    return handleRatingClick(rating);
  };
  var handleKeyPress = function handleKeyPress() {
    handleRatingClick(rating);
  };

  /**
   * Bit messy this next bit of logic but has to be done to keep Typescript happy
   */
  var classArray = [_classes.Classes.SCORECARD_SELECT_ITEM, _defineProperty({}, _classes.Classes.ACTIVE, isActive)];
  if (activeRating && rating <= activeRating) {
    var ratingClass = _classes.Classes.discreteRatingClass(activeRating);
    if (ratingClass) classArray.push(ratingClass);
  }
  var classes = (0, _classnames.default)(classArray);
  var style = fill ? {
    flexGrow: 1
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    onClick: handleClick,
    style: style,
    onKeyPress: handleKeyPress,
    role: "button",
    tabIndex: 0
  }, content);
}